import React from "react";
import { gtmConstant } from "../../constants/gtmConstant";
import {sendDataLayer} from "../../../src/actions/gtmService";
export default class PrivacyButton extends React.Component {
  handleClick = () => {
    // שולחת את האירוע ל-GTM
    sendDataLayer(gtmConstant.SecretCode.FUNNEL_CLICK, {
      process_type: gtmConstant.SecretCode.PROCESS_NAME,
      step_title: gtmConstant.SecretCode.STEP_TITLE.CARD_SELECTION,
      step_number: 1,
      click_text: 'הציגו את הקוד'
    });

    // קוראת לפונקציה המקורית
    this.props.onGetPin();
  };

  render() {
    return (
      <div className="btn-show-secret-code">
        <button
          aria-label="שחזור קוד סודי - כפתור"
          type="button"
          className="btn bg-m color-n color-nl"
          onClick={this.handleClick}
        >
          הציגו את הקוד
        </button>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/card/PrivacyButton.jsx